import { useQuery } from '@apollo/client';
import { Cancel, People } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import {
  ClearAllButton,
  ClearAllContainer,
  LegacyFilterContainer,
} from '~/components/Filter/styles';
import { MultiChip } from '~/components/inputs';
import { useAppContext } from '~/contexts';
import { useFilters } from '../lib';
import { AuditLogsDynamicFiltersDocument } from '../queries/list.generated';

export const Filter = () => {
  const { t } = useTranslation();
  const { currentNetwork } = useAppContext();

  const { data } = useQuery(AuditLogsDynamicFiltersDocument, {
    variables: {
      networkId: currentNetwork.id,
    },
    fetchPolicy: 'cache-first',
  });

  const auditUsers = data?.network?.userIds.nodes || [];

  const { handleClear, setAuditUsers, users, updateSearchParams } = useFilters(auditUsers);

  return (
    <LegacyFilterContainer>
      {auditUsers.length > 0 && (
        <MultiChip
          Icon={People}
          items={users}
          label={t('components.audit_logs.misc.users')}
          onClick={(_, newState) => {
            setAuditUsers(() => newState);
            updateSearchParams('users', newState);
          }}
        />
      )}
      <ClearAllContainer>
        <ClearAllButton onClick={handleClear} startIcon={<Cancel />}>
          {t('components.audit_logs.actions.clear_all_filters')}
        </ClearAllButton>
      </ClearAllContainer>
    </LegacyFilterContainer>
  );
};
